import { useTranslation } from 'react-i18next';
import Dropdown from 'react-bootstrap/Dropdown';

import { FaAngleDown } from "react-icons/fa6";
import styles from "./styles.module.css";


const LANGUAGES: {
    [key: string]: string
} = {
    en: "English",
    ar: "Arabic"
}

interface LangMenuProp {
    extraStyles?: { [key: string]: string },
    className?: string;
    menuClassName?: string;

}

const LangMenu = ({ extraStyles, className, menuClassName }: LangMenuProp) => {
    const { i18n } = useTranslation(['common']);

    const changeLanguageHandle = (lang: string) => {
        return i18n.changeLanguage(lang);
    }

    return (
        <Dropdown>
            <Dropdown.Toggle id="dropdown-basic" style={extraStyles} className={`${styles.lang__btn} ${className}`}>
                {LANGUAGES[i18n.language]}
                <FaAngleDown />
            </Dropdown.Toggle>

            <Dropdown.Menu className={[styles.lang__dropdown, menuClassName].join(' ')}>
                <Dropdown.Item onClick={() => changeLanguageHandle("ar")}>
                    Arabic
                </Dropdown.Item>
                <Dropdown.Item onClick={() => changeLanguageHandle("en")}>
                    English
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    )
}

export default LangMenu;